import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import authEn from './locales/en/auth.json';
import commonEn from './locales/en/common.json';
import dashboardEn from './locales/en/dashboard.json';
import headerEn from './locales/en/header.json';
import historicalNotesEn from './locales/en/historicalNotes.json';
import sidebarEn from './locales/en/sideBar.json';
import authEs from './locales/es/auth.json';
import commonEs from './locales/es/common.json';
import dashboardEs from './locales/es/dashboard.json';
import headerEs from './locales/es/header.json';
import historicalNotesEs from './locales/es/historicalNotes.json';
import sidebarEs from './locales/es/sideBar.json';
import sessionNotesEn from './locales/en/sessionNotes.json';
import sessionNotesEs from './locales/es/sessionNotes.json';
import invoiceEn from './locales/en/invoice.json';
import invoiceEs from './locales/es/invoice.json';

import type { DetectorOptions } from 'i18next-browser-languagedetector';
export const DEFAULT_LANGUAGE = 'en';
export const SUPPORTED_LANGUAGES = ['en', 'es'] as const;
export const LOOKUP_STORAGE = 'sessionStorage';
export const LOOKUP_SESSION_STORAGE = 'i18nextLng';

const resources = {
  en: {
    common: commonEn,
    auth: authEn,
    dashboard: dashboardEn,
    header: headerEn,
    sideBar: sidebarEn,
    invoice: invoiceEn,
    historicalNotes: historicalNotesEn,
    sessionNotes: sessionNotesEn,
  },
  es: {
    common: commonEs,
    auth: authEs,
    dashboard: dashboardEs,
    header: headerEs,
    sideBar: sidebarEs,
    invoice: invoiceEs,
    historicalNotes: historicalNotesEs,
    sessionNotes: sessionNotesEs,
  },
} as const;

const detectionOptions: DetectorOptions = {
  order: [LOOKUP_STORAGE, 'navigator', 'htmlTag'],
  caches: [LOOKUP_STORAGE],
  lookupSessionStorage: LOOKUP_SESSION_STORAGE,
} as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: SUPPORTED_LANGUAGES,
    ns: [
      'common',
      'auth',
      'dashboard',
      'sessionNotes',
      'invoice',
      'header',
      'sideBar',
      'historicalNotes',
    ],
    defaultNS: 'common',
    detection: detectionOptions,
    interpolation: {
      escapeValue: false,
    },
    returnNull: false,
    returnEmptyString: true,
    keySeparator: '.',
    debug: process.env.NODE_ENV === 'development',
    react: {
      useSuspense: true,
    },
  });

if (globalThis.document) {
  const updateDocumentLanguage = (language: string) => {
    document.documentElement.lang = language;
  };

  updateDocumentLanguage(i18n.language);

  i18n.on('languageChanged', (lng) => {
    updateDocumentLanguage(lng);
  });
}

export default i18n;
